import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import AdminDashboard from './pages/AdminDashboard';
import UsersManagement from './pages/UsersManagement';
import CiviliansManagement from './pages/CiviliansManagement';
import TimeRecordsManagement from './pages/TimeRecordsManagement';
import BulkTimeRecords from './pages/BulkTimeRecords';
import ReportsManagement from './pages/ReportsManagement';
import AuditLogs from './pages/AuditLogs';
import UserDashboard from './pages/UserDashboard';
import PositionsManagement from './pages/PositionsManagement';
import UserLicensesManagement from './pages/UserLicensesManagement';
import FiscalDashboard from './pages/FiscalDashboard';
import VisualizadorDashboard from './pages/VisualizadorDashboard';
import AutoCloseConfig from './pages/AutoCloseConfig';
import FaceConfigPage from './pages/FaceConfigPage';
import SchoolLocationConfigPage from './pages/SchoolLocationConfigPage';
import HourCapsPage from './pages/HourCapsPage';
import EscalaAdminPage from './pages/EscalaAdminPage';
import EscalaPage from './pages/EscalaPage';
import EscalaImpressaoPage from './pages/EscalaImpressaoPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/ponto">
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute adminOnly>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/users"
            element={
              <PrivateRoute adminOnly>
                <UsersManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/civilians"
            element={
              <PrivateRoute adminOnly>
                <CiviliansManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/time-records"
            element={
              <PrivateRoute adminOnly>
                <TimeRecordsManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/lancamento-massa"
            element={
              <PrivateRoute adminOnly>
                <BulkTimeRecords />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/reports"
            element={
              <PrivateRoute adminOnly>
                <ReportsManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/positions"
            element={
              <PrivateRoute adminOnly>
                <PositionsManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/licenses"
            element={
              <PrivateRoute adminOnly>
                <UserLicensesManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/audit"
            element={
              <PrivateRoute adminOnly>
                <AuditLogs />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/auto-close"
            element={
              <PrivateRoute adminOnly>
                <AutoCloseConfig />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/face"
            element={
              <PrivateRoute adminOnly>
                <FaceConfigPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/school-location"
            element={
              <PrivateRoute adminOnly>
                <SchoolLocationConfigPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/limites"
            element={
              <PrivateRoute adminOnly>
                <HourCapsPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/escala"
            element={
              <PrivateRoute adminOnly>
                <EscalaAdminPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/escala/:cicloId"
            element={
              <PrivateRoute adminOnly>
                <EscalaAdminPage />
              </PrivateRoute>
            }
          />

          {/* Escala publicada: todo perfil logado consulta; quem é itinerante pede vaga. */}
          <Route
            path="/escala"
            element={
              <PrivateRoute>
                <EscalaPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/escala/:id/impressao"
            element={
              <PrivateRoute>
                <EscalaImpressaoPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/user/dashboard"
            element={
              <PrivateRoute>
                <UserDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/fiscal/dashboard"
            element={
              <PrivateRoute fiscalOnly>
                <FiscalDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/visualizador/dashboard"
            element={
              <PrivateRoute visualizadorOnly>
                <VisualizadorDashboard />
              </PrivateRoute>
            }
          />

          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
